import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = t(
  (a, r) => /* @__PURE__ */ o.jsx(
    e,
    {
      ref: r,
      ...a,
      image: (s) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M4.5 1.938a1 1 0 0 0-1.5.866v10.392a1 1 0 0 0 1.5.866l9-5.196a1 1 0 0 0 0-1.732z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "PlayIcon";
export {
  i as PlayIcon,
  i as default
};
//# sourceMappingURL=index.js.map
